<template>
	<div @mouseenter.stop.prevent="canShowBtn?isShowBtn = true:''" @mouseleave.stop.prevent="canShowBtn?isShowBtn = false:''" class="ultimate-scroll-container" ref="container" >
		<div class="scroll-controls">
			<button style="position: absolute;z-index: 100;" v-if="(equipment == 'pc'  && isShowBtn) || equipment == 'phone'"  class="nav-btn left" @click="smoothScroll('left')" :disabled="isAtStart">
				<svg viewBox="0 0 24 24">
					<path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
				</svg>
			</button>
			<!-- @mousedown.stop.prevent="dragStart" @mousemove.stop.prevent="dragMove" @mouseup.stop.prevent="dragEnd"
							@mouseleave.stop.prevent="dragEnd" @touchstart.stop.prevent="touchStart" @touchmove.stop.prevente="touchMove" @touchend.stop.prevent="touchEnd" -->
			<div
			
			 class="scroll-viewport" ref="viewport" style="">
				<div class="scroll-content" ref="content" :style="{
            transform: `translateX(${-scrollPos}px)`,
            transition: isDragging ? 'none' : currentTransition,
			paddingLeft:isShowBtn? '40px':'6px',
			paddingRight:isShowBtn? '40px':'6px'
          }">
					<slot></slot>
				</div>
			</div>
			<button style="position: absolute;z-index: 100;right: 0px;" v-if="(equipment == 'pc'  && isShowBtn) || equipment == 'phone'" class="nav-btn right" @click="smoothScroll('right')" :disabled="isAtEnd">
				<svg viewBox="0 0 24 24">
					<path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
				</svg>
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'UltimateScroll',
		props: {
			equipment: {
				type: String,
				default: "pc"
			},
		},
		data() {
			return {
				canShowBtn:true,
				isShowBtn:false,
				isDragging: false,
				startX: 0,
				startPos: 0,
				scrollPos: 0,
				maxScroll: 0,
				viewWidth: 0,
				contentWidth: 0,
				velocity: 0,
				lastPos: 0,
				lastTime: 0,
				animFrame: null,
				isTouch: false,
				currentTransition: 'transform 0.45s cubic-bezier(0.33, 1, 0.68, 1)',
				damping: 0.92,
				minVelocity: 0.5,
				isScrolling: false,
				resizeObserver: null,
				mutationObserver: null,
				containerPadding: 24 // 容器两侧内边距总和
			}
		},
		computed: {
			isAtStart() {
				return this.scrollPos <= 0
			},
			isAtEnd() {
				// 添加1px容差避免浮点数精度问题
				return this.scrollPos >= this.maxScroll - 1
			}
		},
		mounted() {
			this.isTouch = 'ontouchstart' in window
			this.initDimensions()
			this.setupObservers()
			window.addEventListener('resize', this.handleResize)
			if (!this.isTouch) {
				// this.$refs.viewport.addEventListener('wheel', this.handleWheel, {
				// 	passive: false
				// })
			}
		},
		beforeDestroy() {
			this.cleanupObservers()
			window.removeEventListener('resize', this.handleResize)
			if (!this.isTouch) {
				this.$refs.viewport.removeEventListener('wheel', this.handleWheel)
			}
			cancelAnimationFrame(this.animFrame)
		},
		methods: {
			initDimensions() {
				this.$nextTick(() => {
					const container = this.$refs.container
					if (!container) return

					// 1. 获取容器实际可用宽度
					const containerWidth = container.clientWidth
					const buttonsWidth = 88 // 两个按钮宽度 (44px x 2)
					
					console.log('containerWidth',containerWidth)

					// 2. 计算视口可用宽度 (容器宽度 - 按钮 - 内边距)
					this.viewWidth = containerWidth - buttonsWidth - this.containerPadding
					this.$refs.viewport.style.width = `${this.viewWidth}px`

					// 3. 计算内容总宽度和最大滚动位置
					this.contentWidth = this.$refs.content.scrollWidth
					
					if(this.viewWidth > this.contentWidth) {
						this.canShowBtn = false
					}
					
					this.maxScroll = Math.max(0, this.contentWidth - this.viewWidth)

					// 4. 确保当前滚动位置有效
					this.scrollPos = Math.min(this.scrollPos, this.maxScroll)

					// 5. 特殊处理：当内容不足时禁用按钮
					if (this.contentWidth <= this.viewWidth) {
						this.scrollPos = 0
					}
				})
			},
			setupObservers() {
				// 监听容器尺寸变化
				if (typeof ResizeObserver !== 'undefined') {
					this.resizeObserver = new ResizeObserver(() => {
						this.initDimensions()
					})
					this.resizeObserver.observe(this.$refs.container)
				}

				// 监听内容变化
				if (typeof MutationObserver !== 'undefined') {
					this.mutationObserver = new MutationObserver(() => {
						this.$nextTick(() => {
							this.initDimensions()
						})
					})
					this.mutationObserver.observe(this.$refs.content, {
						childList: true,
						subtree: true,
						attributes: true
					})
				}
			},
			cleanupObservers() {
				this.resizeObserver?.disconnect()
				this.mutationObserver?.disconnect()
			},
			handleResize() {
				cancelAnimationFrame(this.animFrame)
				this.initDimensions()
			},
			dragStart(e) {
				if (this.isScrolling) return
				e.preventDefault()

				this.isDragging = true
				this.startX = this.getClientX(e)
				this.startPos = this.scrollPos
				this.lastPos = this.scrollPos
				this.lastTime = Date.now()
				this.velocity = 0

				cancelAnimationFrame(this.animFrame)
				this.currentTransition = 'none'

				if (!this.isTouch) {
					document.body.style.cursor = 'grabbing'
					this.$refs.viewport.style.cursor = 'grabbing'
				}
				e.preventDefault();
			},
			dragMove(e) {
				if (!this.isDragging || this.isScrolling) return
				e.preventDefault()

				const now = Date.now()
				const deltaTime = now - this.lastTime
				this.lastTime = now

				const x = this.getClientX(e)
				const deltaX = x - this.startX
				let newPos = this.startPos - deltaX

				// 边界弹性效果
				if (newPos < 0) {
					newPos = 0 - Math.pow(Math.abs(newPos), 0.7)
				} else if (newPos > this.maxScroll) {
					newPos = this.maxScroll + Math.pow(newPos - this.maxScroll, 0.7)
				}

				// 计算速度
				if (deltaTime > 0) {
					this.velocity = (newPos - this.lastPos) / deltaTime
					this.lastPos = newPos
				}

				this.scrollPos = newPos
				e.preventDefault();
			},
			dragEnd(e) {
				if (!this.isDragging || this.isScrolling) return
				this.isDragging = false

				if (!this.isTouch) {
					document.body.style.cursor = ''
					this.$refs.viewport.style.cursor = 'grab'
				}

				this.currentTransition = 'none'
				if (Math.abs(this.velocity) > this.minVelocity) {
					this.applyMomentum()
				} else {
					this.snapToEdge()
				}
				e.preventDefault();
			},
			applyMomentum() {
				this.velocity *= this.damping
				const delta = this.velocity * 16
				let newPos = this.scrollPos + delta

				if (newPos < 0 || newPos > this.maxScroll) {
					// this.velocity *= -0.5
					newPos = Math.max(0, Math.min(newPos, this.maxScroll))
				}

				this.scrollPos = newPos

				if (Math.abs(this.velocity) > this.minVelocity) {
					this.animFrame = requestAnimationFrame(this.applyMomentum)
				} else {
					this.snapToEdge()
				}
			},
			snapToEdge() {
				this.currentTransition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
				this.scrollPos = Math.max(0, Math.min(this.scrollPos, this.maxScroll))
			},
			smoothScroll(direction) {
				if (this.isScrolling || this.maxScroll <= 0) return
				this.isScrolling = true

				const scrollAmount = Math.min(this.viewWidth * 0.8, this.maxScroll)
				let targetPos

				if (direction === 'left') {
					targetPos = Math.max(0, this.scrollPos - scrollAmount)
				} else {
					targetPos = Math.min(this.maxScroll, this.scrollPos + scrollAmount)
				}

				this.currentTransition = 'transform 0.5s cubic-bezier(0.33, 1, 0.68, 1)'
				this.scrollPos = targetPos

				setTimeout(() => {
					this.isScrolling = false
				}, 500)
			},
			handleWheel(e) {
				e.preventDefault()
				this.scrollPos = Math.max(0, Math.min(
					this.scrollPos + e.deltaY * 0.6,
					this.maxScroll
				))
			},
			touchStart(e) {
				this.isTouch = true
				this.dragStart(e)
				e.preventDefault();
			},
			touchMove(e) {
				this.dragMove(e)
				e.preventDefault();
			},
			touchEnd(e) {
				this.dragEnd()
				e.preventDefault();
			},
			getClientX(e) {
				return this.isTouch ? e.touches[0].clientX : e.clientX
			}
		}
	}
</script>

<style scoped>
	.ultimate-scroll-container {
		width: 100%;
		box-sizing: border-box;
		/* padding: 0 12px; */
		/* 两侧内边距 */
	}

	.scroll-controls {
		display: flex;
		align-items: center;
		width: 100%;
		position: relative;
	}

	.scroll-viewport {
		overflow: hidden;
		position: relative;
		cursor: grab;
		-webkit-overflow-scrolling: touch;
		flex: 1;
		min-width: 0;
		width: calc(100% - 88px);
		/* 总宽度减去按钮宽度 */
	}

	.scroll-viewport:active {
		cursor: grabbing;
	}

	.scroll-content {
		display: inline-flex;
		white-space: nowrap;
		will-change: transform;
		user-select: none;
		backface-visibility: hidden;
		transform: translateZ(0);
		height: 100%;
	}

	.nav-btn {
		width: 34px;
		height: 34px;
		border-radius: 50%;
		border: none;
		background: rgba(0, 0, 0, 0.7);
		color: white;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0;
		transition: all 0.2s ease;
		flex-shrink: 0;
		padding: 0;
		outline: none;
	}

	.nav-btn.left {
		margin-right: 12px;
	}

	.nav-btn.right {
		margin-left: 12px;
	}

	.nav-btn:hover:not(:disabled) {
		background: rgba(0, 0, 0, 0.9);
	}

	.nav-btn:disabled {
		opacity: 0.3;
		cursor: not-allowed;
	}

	.nav-btn svg {
		width: 24px;
		height: 24px;
		fill: currentColor;
	}

	/* 确保子元素不会影响布局 */
	.scroll-content>* {
		flex-shrink: 0;
		display: inline-block;
	}
</style>